var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconArrowRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 11.31377 11.31377",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_draw down")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pool_pool",
    transform: "translate(-1138.343115, -245.343115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-34",
    transform: "translate(69.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_draw-down",
    transform: "translate(1076.000000, 81.000000) rotate(-90.000000) translate(-1076.000000, -81.000000) translate(1068.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    stroke: "#3B199F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.000000, 7.000000) rotate(-315.000000) translate(-8.000000, -7.000000) ",
    points: "11 4 10.7213203 9.72132034 5 10"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_arrow_right.ed6cb13d.svg";
export { ForwardRef as ReactComponent };